export default "__VITE_ASSET__2a7e77d2__"